import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1jikka7-0"
})(["padding:", " ", " ", ";", ""], rem(24), rem(24), rem(16), media.md(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding-left: ", ";\n        padding-right: ", ";\n    "])), rem(32), rem(32)));
export default Container;